import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';

import type { PrivateNavbarMenuAction } from '@/app/layouts/private-layout/menu/menu';
import { CartQuotationFacade } from '@/app/features/shared/quotation/facades/cart-quotation.facade';
import { AuthService } from '@/app/features/auth/services/auth.service';

@Injectable({ providedIn: 'root' })
export class PrivateNavbarFacade {
  private readonly cartQuotationFacade = inject(CartQuotationFacade);
  private readonly authService = inject(AuthService);
  private readonly _menuOpen = new BehaviorSubject<boolean>(false);

  readonly menuOpen$ = this._menuOpen.asObservable();
  readonly searchClearedAt = this.cartQuotationFacade.searchClearedAt;

  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe(() => {
        this.closeMenu();
      });
  }

  searchOrQuote(value: string): void {
    this.cartQuotationFacade.searchOrQuote(value);
  }

  openNotifications(): void {}

  openMenu(): void {
    this.toggleMenu();
  }

  toggleMenu(): void {
    this._menuOpen.next(!this._menuOpen.getValue());
  }

  closeMenu(): void {
    this._menuOpen.next(false);
  }

  handleMenuAction(action: PrivateNavbarMenuAction): void {
    // "Mi cuenta" e "Ingresar" ahora son enlaces reales dentro del menú (routerLink), así que
    // acá solo queda lo que no es navegación.
    if (action === 'logout') {
      this.closeMenu();
      this.authService.logout();
    }
  }
}
